
import React from "react";
import { Button } from "@/components/ui/button";
import { ArrowLeft, Trash2, Save, CheckCircle } from "lucide-react";

interface EntryEditorHeaderProps {
  isNewEntry: boolean;
  saving: boolean;
  autoSaving: boolean;
  lastSaved: Date | null;
  onSave: () => void;
  onDelete: () => void;
  onBack: () => void;
}

export const EntryEditorHeader: React.FC<EntryEditorHeaderProps> = ({
  isNewEntry,
  saving,
  autoSaving,
  lastSaved,
  onSave,
  onDelete,
  onBack
}) => {
  return (
    <div className="flex items-center justify-between mb-6">
      <div className="flex items-center">
        <Button variant="ghost" onClick={onBack} className="mr-2">
          <ArrowLeft className="h-4 w-4" />
        </Button>
        <h1 className="text-2xl font-bold">
          {isNewEntry ? "Create New Entry" : "Edit Entry"}
        </h1>
      </div>
      <div className="flex gap-2 items-center">
        {!isNewEntry && lastSaved && (
          <div className="text-xs text-muted-foreground flex items-center">
            {autoSaving ? (
              <>Saving...</>
            ) : (
              <>
                <CheckCircle className="h-3 w-3 mr-1 text-green-500" />
                Last saved: {lastSaved.toLocaleTimeString()}
              </>
            )}
          </div>
        )}
        {!isNewEntry && (
          <Button variant="destructive" onClick={onDelete}>
            <Trash2 className="h-4 w-4 mr-2" />
            Delete
          </Button>
        )}
        <Button onClick={onSave} disabled={saving}>
          <Save className="h-4 w-4 mr-2" />
          {saving ? "Saving..." : "Save"}
        </Button>
      </div>
    </div>
  );
};
